import React from 'react';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import useApp from 'hooks/useApp';
const Forbidden = (props) => {
    const app = useApp()
    return (
        <div className="container flex align-items-center justify-content-center" style={{ height: '100vh' }}>
            <div className="grid flex-column align-items-center card">
                <div className="text-pink-500 font-bold text-5xl">403</div>
                <Avatar size="xlarge" icon="pi pi-lock" className="text-pink-500 bg-pink-100  my-4" />
                <div className="text-900 font-medium text-3xl mb-2">{props.message}</div>
                <div className="text-gray-200 text-2xl">Você não tem permissão de acessar este recurso. Contate o Administrador.</div>
                <div className="mt-5 text-center">
                    <Button onClick={() => app.navigate('/home')} icon="pi pi-arrow-left" label="Pagina Inicial" />
                </div>
            </div>
        </div>
    )
}

Forbidden.defaultProps = {
    message: "Acesso Negado!"
}



export default Forbidden;